export const ERRCODES = {
  '404': 'No data found.',
  '503': 'We are upgrading the site. Please come back later.',
  '407': 'We are upgrading the site. Please come back later.',
  '409 ': 'Price Info not matched.',
  '408': 'We couldn\'t complete your request. Please try again later.',
  '400 ': 'Requested Cart data not valid.',
  '401 ': 'Unauthorized.',
  '412': 'Request Header Not Found.',
  '0': 'We are upgrading the site. Please come back later.',
  '500': 'Sorry! There was an error while processing your request. Please try again!',
  'undefined': ' undefined',
  'FETCH_PAGE': 'Error while loading Page contents.',
  'FETCH_FANSUMMARY': 'Error while loading account Summary.',
  'FETCH_DEVICESUMMARY': 'Error while loading Device Summary.',
  'FETCH_APPLECERT_STATUS': 'Error while loading Apple Certificate Status.',
  'genericErrorMessage' : "Something went wrong. We're unable to process your request. Please try again later.",
  'ABM_FE_GENERIC_ERROR_MESSAGE' : 'Something went wrong. Please enroll in Apple Business with Apple and return to AT&T Device Management Program to complete signup.',
  'ABM_FE_COMMON_ERROR_MESSAGE': 'Something went wrong. Please try again later.',
  'ABM_FE_INVALID_DUNS_ERROR_MESSAGE': "We're sorry. We were not able to validate your DUNS information. Please contact your account manager.",
};
